import type { LicensingIssueType } from './issuesV2';
import type { LicensingRuleType } from './model-typings';

/**
 * Helper to determine if a licenseId is indicative of a custom license.
 * @param licenseId LicenseID / signature of the license to check
 * @returns Whether or not the license supports custom title / text
 */
export const isCustomLicense = (licenseId: string): boolean => {
  return ['custom-license', 'proprietary-license'].includes(licenseId);
};

const ruleTypeNames: Record<LicensingIssueType | LicensingRuleType, string> = {
  denied_license: 'denied license',
  flagged_license: 'flagged license',
  approved_license: 'approved license',
  unlicensed_dependency: 'unlicensed dependency',
  policy_conflict: 'denied license',
  policy_flag: 'flagged license',
};

export const getRuleTypeName = (ruleType: LicensingIssueType | LicensingRuleType): string => {
  return ruleTypeNames[ruleType];
};
